import { forwardRef, type Ref, type SVGProps } from "react";
const IconCheckmarkOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29.7 6.31a1 1 0 0 0-1.41 0L11.49 23.9l-7.78-8.14a1 1 0 0 0-1.41 0 1.08 1.08 0 0 0 0 1.48l8.47 8.87a1 1 0 0 0 1.44 0L29.7 7.79a1.08 1.08 0 0 0 0-1.48" />
  </svg>
);
const ForwardRef = forwardRef(IconCheckmarkOutlineSVG);
ForwardRef.displayName = "IconCheckmarkOutline";
export { ForwardRef as IconCheckmarkOutline };
